import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "area-chart",
  "use": "area-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"area-chart\"><path fill-rule=\"evenodd\" d=\"M22 22H2v-4.5l7.5-7.495 4 3.995L22 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol